<template>
  <article class="article">
    <article-metadata :article="article" />
    <slot name="cover" />
    <article-main :article="article" />
    <slot name="footer" />
  </article>
</template>

<script>
import ArticleMain from './articleMain'
import ArticleMetadata from './articleMetadata'

export default {
  components: {
    'article-main': ArticleMain,
    'article-metadata': ArticleMetadata,
  },
  props: {
    /**
     * Article data
     */
    article: {
      required: true,
      type: Object,
    },
  },
}
</script>

<style lang="postcss" scoped>
/* Article base styles */
.article::v-deep {
  @apply mx-auto break-words;

  & * {
    @apply leading-normal;
  }
  & h1,
  & h2,
  & h3,
  & h4 {
    @apply font-bold;
  }
  & h5,
  & h6 {
    @apply font-normal;
  }

  & b,
  & strong {
    @apply font-bold;
  }
  & i,
  & em {
    @apply italic;
  }
  & u {
    @apply underline;
  }
  & a {
    @apply text-indigo;
  }

  & ol {
    @apply list-decimal;
  }
  & ul {
    @apply list-disc;
  }
  & li {
    margin-left: 2em;
  }

  & figure {
    @apply w-full mx-auto;
  }
  & hr {
    @apply w-full text-teal-medium border-0 border-t-2;
  }
}

@screen mobile {
  /* Article base styles */
  .article::v-deep {
    & h1 {
      font-size: 36px;
    }
    & h2 {
      font-size: 26px;
    }
    & h3 {
      font-size: 20px;
    }
    & a:focus {
      @apply underline;
    }
  }
}

@screen desktop {
  /* Article base styles */
  .article::v-deep {
    & h1 {
      font-size: 48px;
    }
    & h2 {
      font-size: 36px;
    }
    & h3 {
      font-size: 26px;
    }
    & a:hover {
      @apply underline;
    }
  }
}
</style>
